import * as React from 'react';
import Glyphicon from 'source/app/presentation/Shared/Glyphicon/Glyphicon';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from 'source/app/presentation/Shared/Styles/CSS';

export function ExpiredKeyValueIcon() {
	return (
		<Glyphicon
			icon={EGlyphicon['warning-sign']}
			withClass={StyleClass(`selectorBox_expiredSign`, {
				color: 'darkgoldenrod',
				textShadow: '0px 0px 4px rgba(184, 134, 11, 0.55)',
				position: 'relative',
				top: '2px',
				':hover': {
					textShadow: '0px 0px 15px gold',
					transition: `all 0.5s`
				}
			})}
		/>
	);
}
